import React, { useState, useEffect } from "react";
import { Select, DatePicker, Input, Button, Form } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import Filterloader from "../../../components/loader";
import * as zoneActions from "../../../redux/actions/zone.actions";
import * as actionPage from "../../../redux/actions/work.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import moment from "moment";

const { RangePicker } = DatePicker;

const statusOption = [
  { label: "Open", value: "open" },
  { label: "In Process", value: "in-process" },
  { label: "Completed", value: "completed" },
  { label: "Cancel", value: "cancel" },
];

const WorkFilters = (props) => {
  const { onFilterChange } = props;
  const [form] = Form.useForm();
  const [postDataZone, setPostDataZone] = useState(null);
  const [postDataZoneIdsAll, setPostDataZoneIdsAll] = useState([]);

  // Load zone list on mount
  useEffect(() => {
    props.zoneActions.getZoneListAction();
  }, []);

  // Populate zone options when zoneData updates
  useEffect(() => {
    if (props.zoneData) {
      const zoneData = [];
      const zoneDataAll = [];
      props.zoneData.map((item) => {
        zoneData.push({ value: item?.storeId, label: item?.zoneName });
        zoneDataAll.push(item?.storeId);
      });
      setPostDataZoneIdsAll(zoneDataAll);
      setPostDataZone([{ value: "all", label: "---SELECT ALL---" }, ...zoneData]);
    }
  }, [props.zoneData]);

  // Handle "Select All" for zones
  const onChangeHandelZone = (value) => {
    if (value?.includes("all")) {
      form.setFieldsValue({
        ...props.workFilter,
        storeId: postDataZoneIdsAll,
      });
    }
  };

  // Sync existing filters from redux into form
  useEffect(() => {
    if (props.pageFilter) {
      form.setFieldsValue(props.pageFilter || null);
    }
  }, [props.pageFilter]);

  // Search / Filter handler — only notify parent; parent performs the single API call (avoids duplicate /work/list)
  const filterChange = async (value) => {
    const newData = {
      ...props.pageFilter,
      ...value,
      page: 1,
    };
    if (Array.isArray(newData.status)) {
      newData.status = newData.status.join(",");
    }
    if (Array.isArray(newData.storeId)) {
      newData.storeId = newData.storeId.join(",");
    }
    if (onFilterChange) onFilterChange(newData);
  };

  // Reset handler — only notify parent; parent performs the single API call (avoids duplicate /work/list)
  const resetSearch = async () => {
    const today = moment();
    const newData = {
      page: 1,
      limit: 10,
      orderCreationDate: [moment(), moment()],
      status: "",
      storeId: "", 
      sort: "desc",
    };
    form.resetFields();
    form.setFieldsValue({
      orderCreationDate: [today, today],
    });
    if (onFilterChange) onFilterChange(newData);
  };

  return props?.pageLoading ? (
    <Filterloader />
  ) : (
    <Form
      form={form}
      className="fliters_form"
      onFinish={filterChange}
      layout="vertical"
      initialValues={{
        orderCreationDate: [moment(), moment()], // set today as default
      }}
    >
      {/* Zone Filter */}
      <Form.Item name={["storeId"]} label={"Zone"}>
        <Select
          showSearch
          allowClear
          mode="multiple"
          optionFilterProp="children"
          filterOption={(input, option)=>(option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
          options={postDataZone}
          style={{ minWidth: 300 }}
          placeholder="Zone"
          onChange={onChangeHandelZone}
        />
      </Form.Item>

      {/* Status Filter */}
      <Form.Item name={["status"]} label={"Status"}>
        <Select
          showSearch
          allowClear
          mode="multiple"
          options={statusOption}
          style={{ minWidth: 160 }}
          placeholder="Status"
        />
      </Form.Item>

      {/* Order Creation Date Range */}
      <Form.Item 
        name={["orderCreationDate"]} 
        label={"Order Creation Date"}
      >
        <RangePicker allowClear={false} format="YYYY-MM-DD" />
      </Form.Item>

       {/* Packed Time Range */}
      {/* <Form.Item 
        name={["packedDate"]} 
        label={"Packed Time"}
        >
        <RangePicker allowClear={false} format="YYYY-MM-DD" />
      </Form.Item> */}

      {/* Picture Packed Time Range */}
      {/* <Form.Item 
        name={["picturePackedDate"]} 
        label={"Picture Packed Time"}
        >
        <RangePicker allowClear={false} format="YYYY-MM-DD" />
      </Form.Item> */}

      {/* Order ID */}
      <Form.Item name={["orderId"]} label={"Order ID"}>
        <Input allowClear style={{ width: 150 }} placeholder="Order ID" />
      </Form.Item>

      <Button htmlType="submit" loading={props?.pageLoading}>
        Search <SearchOutlined />
      </Button>
      <Button loading={props?.pageLoading} onClick={resetSearch}>
        Reset
      </Button>
    </Form>
  );
};

const mapStateToProps = (state) => {
  return {
    zoneData: state.ZoneReducer.zoneData,
    workData: state.WorkReducer.workData,
    workPagination: state.WorkReducer.workPagination,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    zoneActions: bindActionCreators(zoneActions, dispatch),
    actionPage: bindActionCreators(actionPage, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WorkFilters);
